module.exports = __webpack_public_path__ + "static/media/tunde.5d27b2c6.png";